import PicklistMetadata from "../PicklistMetadata";

// Non-static picklist over the RuleCurrent EC, used to pick a relationship's PARENT rule.
// Display = the rule's Name; value = RuleUSID (the LOGICAL rule, not a revision) so the relationship
// survives every revise on that end. RuleCurrent lists exactly one row per rule — the revision it
// currently resolves to — which is why a never-published DRAFT is still pickable here.
class RuleParentPicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "RuleParent";
        this.static = false;
        this.enterpriseComponent = "RuleCurrent";
        this.useRealm = false;
        this.searchSpecification = null;
        this.sortSpecification = {"Name": "ASC"};
        this.typeField = "Name";
        this.typeValue = "RuleUSID";
        this.allowNoSelection = false;
    }
}

export default RuleParentPicklistMetadata;
